import attributes from '../constants/attributes';

const getBlockCategoryByElement = (element) => {
  if (!element) return null;

  return element.getAttribute(attributes.CATEGORY_ATTRIBUTE_NAME);
};

export default getBlockCategoryByElement;
